globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.LimitlessPlugins = appCustomerSpace.LimitlessPlugins || {};

appCustomerSpace.LimitlessPlugins.FancyBox = (function(){

  FancyBox.selector = '[data-popup="fancybox"]';

  FancyBox.initAll = function($html) {
    $html.find(FancyBox.selector).each(function() {
      new FancyBox($(this)).init();
    })
  }

  function FancyBox($html) {
    this.$html = $html;
  }

  // TODO Check and add potential options
  FancyBox.prototype = {
    init: function(){
      this.$html.fancybox({
        aspectRatio: false,
        maxWidth: '80%',
        height: 'auto'
      });
    }
  }

  return FancyBox;

})();
